import Parse from 'parse'
import moment from 'moment-timezone'
moment.tz.setDefault('America/Mexico_City')

class Promocode extends Parse.Object {
  constructor() {
    super('Promocode')
  }

  get objectId() {
    return this.get('id')
  }

  get name() {
    return this.get('name')
  }

  get description() {
    return this.get('description')
  }

  get discount() {
    return this.get('discount')
  }

  get quantity() {
    return this.get('quantity')
  }

  get used() {
    return this.get('used')
  }

  get title() {
    return this.get('title')
  }

  get code() {
    return this.get('code')
  }

  get available() {
    return this.get('available')
  }

  get expiration() {
    return moment(this.get('expirationDate')).format('dddd DD MMMM, YYYY')
  }

  get maxDiscountMxn() {
    return this.get('maxDiscountMxn')
  }

  get isPercentage() {
    return this.get('isPercentage')
  }

  static changeStatus(promocode) {
    let id = promocode.id
    let pc = Promocode.createWithoutData(id)

    pc.set('enabled', false)
    return pc.save()
  }

  static getObject(id) {
    return new Parse.Query(this).get(id)
  }

  static count() {
    return new Parse.Query(this).count()
  }

  static load(limit = 500, skip = 0) {
    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .descending('createdAt')
      .equalTo('enabled', true)
      .find()
  }

  static create(params, code) {
    if (params.reutilizable == 1) {
      params.reutilizable = true
    } else {
      params.reutilizable = false
    }

    if (params.nuevosUsuarios == true) {
      params.nuevosUsuarios = 1
    }

    let promocode = new Promocode()

    promocode.set('name', params.nombre)
    promocode.set('description', params.descripcion)
    promocode.set('discount', Number(params.descuento))
    promocode.set('code', params.codigo)
    promocode.set('quantity', Number(params.cantidad))
    promocode.set('available', Number(params.cantidad))
    promocode.set('used', 0)
    promocode.set('isReusable', params.reutilizable)
    promocode.set('firstOrderOnly', params.nuevosUsuarios)
    promocode.set('expirationDate', params.fecha)
    promocode.set('enabled', true)
    promocode.set('maxDiscountMxn', Number(params.max_discount))
    promocode.set('isPercentage', Boolean(params.is_percentage))

    return promocode.save()
  }

  dump() {
    console.log(this)
  }
}

export default Promocode
